import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import NativeImageViewer from 'react-native-image-zoom-viewer';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Icon } from '../icon';

const ImageViewer = ({
	close,
	...passThroughProps
}) => {
	const insets = useSafeAreaInsets();
	const canClose = typeof close === 'function';
	const closeHitSlop = { top: 10, bottom: 10, left: 10, right: 10 };

	return (
		<View style={styles.container}>
			<NativeImageViewer
				enableSwipeDown={canClose}
				onSwipeDown={canClose ? close : undefined}
				onCancel={canClose ? close : undefined}
				{...passThroughProps}
			/>
			{
				canClose && (
					// Render an explicit overlay control so the close button stays clickable on Android.
					<TouchableOpacity
						accessibilityLabel="Close image viewer"
						accessibilityRole="button"
						hitSlop={closeHitSlop}
						onPress={close}
						style={[styles.closeButton, { top: Math.max(insets.top, 12) }]}
					>
						<Icon name="close" />
					</TouchableOpacity>
				)
			}
		</View>
	);
};

export default ImageViewer;

const styles = StyleSheet.create({
	container: {
		flex: 1,
	},
	closeButton: {
		position: 'absolute',
		left: 20,
		zIndex: 2,
		elevation: 2,
	},
});
